const BusinessEntity = require('./business_entity').default;

class Debtor extends BusinessEntity {};

Debtor.attributeName('fullName', 'Primary Contact Name');

Debtor.validation('fullName', { presence: true, if: (model) => { return model.isAnIndividual; } });

export default Debtor;
